import React, { Component, Fragment } from 'react';
import { defaultTo, isEmpty, path, reduce, last } from 'ramda';
import { withRouter } from 'react-router-dom';

import styles from './styles.m.scss';

import { addPrices, toCurrency, getDiscountFromLineItems } from '../../../../../util/helpers';
import { apiProcessPayment } from '../../../../../api/registration';
import { handleErrorBase, handleSuccessBase } from '../../../../../util/forms';

import Footer from '../../../../../components/Accordion/Footer';
import DiscountForm from '../../../../../components/DiscountForm';
import FormGroup from '../../../../../components/Forms/FormGroup';
import { apiUpdateRegistration } from '../../../../../api/registration';
import FinalPrice from './Components/FinalPrice';
import StripeCheckout from '../../../../../components/StripeCheckout/index';
import { routes } from '../../../..';
import Checkbox from '../../../../../components/Forms/Checkbox';

class Summary extends Component {
  state = {
    certAgreement: false,
    candidateHandbook: false,
  };

  render() {
    const { name, setStep, step, certification, registration, updateRegistration, history } = this.props;
    const { certAgreement, candidateHandbook } = this.state;
    if (isEmpty(registration)) return <noscript />;
    const reviews = defaultTo([], registration.reviews);
    const lastReview = defaultTo({}, last(reviews));

    const materials = [];
    const trainings = defaultTo([], registration.trainings);
    const fees = defaultTo([], registration.registrationFees);
    const internationalFees = defaultTo([], registration.internationalFees).filter((fee) => fee.materials == true);
    const internationalExamFees = defaultTo([], registration.internationalFees).filter((fee) => fee.exams == true);
    const courseMaterials = defaultTo([], registration.courseMaterials);
    const events = defaultTo([], registration.events);
    materials.push(...courseMaterials, ...events);
    const membership = defaultTo({}, path(['memberships', 0], registration));
    const exams = defaultTo([], registration.exams);
    const donation = defaultTo({}, path(['donations', 0], registration));
    donation.price = donation.finalPrice;
    const lineItems = [...trainings, ...fees, ...internationalFees, ...materials, membership, donation];
    const discount = getDiscountFromLineItems(lineItems);
    const totalPrices = reduce(addPrices, { total: 0, afterDiscount: 0 }, lineItems);
    const examPrice = reduce(addPrices, { total: 0, afterDiscount: 0 }, [...exams, ...internationalExamFees]);

    // TODO: Make less hardcoded
    const isAFC = registration.certificationId == 1;

    return (
      <div>
        <h2 className={styles.stepHeader}>Please review your information</h2>
        <FormGroup label="Registration Details">
          <p>
            <strong>Certification:</strong> {certification.name}
          </p>
          <p>
            <strong>Registration Type:</strong> {path(['pathway', 'name'], registration)}
          </p>
          {!isEmpty(membership) && (
            <p>
              <strong>Membership:</strong> {membership.name}
            </p>
          )}
          {registration.shipping && (
            <div>
              <p>
                <strong>Shipping:</strong>
              </p>
              <p className="pl-5">
                {registration.shipping.name}
                <br />
                {registration.shipping.addressLine1}
                <br />
                {registration.shipping.addressLine2}
                {registration.shipping.addressLine2 && <br />}
                {registration.shipping.city}, {registration.shipping.state} {registration.shipping.zip}{' '}
                {registration.shipping.country}
              </p>
            </div>
          )}
        </FormGroup>
        <DiscountForm
          discount={discount}
          checkDiscount={(discountCode) => apiUpdateRegistration(registration.id, { discountCode })}
          update={(registration) => updateRegistration(registration)}
        />
        <FormGroup label="Total Due">
          <table className="table">
            <thead>
              <tr>
                <th>Description</th>
                <th>Price</th>
                <th>Discount</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {trainings.map((training) => (
                <tr key={training.id}>
                  <th>{training.name}</th>
                  <td>{toCurrency(training.price)}</td>
                  <td>
                    {discount.module && discount.percentage
                      ? `-${discount.amount}%`
                      : training.price - training.finalPrice == 300
                      ? '3 Module Discount ($300)'
                      : ''}
                  </td>
                  <td>
                    <FinalPrice lineItem={training} readonly />
                  </td>
                </tr>
              ))}
              {fees.map((fee) => (
                <tr key={fee.id}>
                  <th>
                    {fee.name} <span className="subtext">*</span>
                  </th>
                  <td>{toCurrency(fee.price)}</td>
                  <td>{discount.registrationFee && discount.percentage && `-${discount.amount}%`}</td>
                  <td>
                    <FinalPrice lineItem={fee} readonly />
                  </td>
                </tr>
              ))}
              {materials.map((material) => (
                <tr key={material.id}>
                  <th>{material.name}</th>
                  <td>{toCurrency(material.price)}</td>
                  <td>{discount.courseMaterials && discount.percentage && `-${discount.amount}%`}</td>
                  <td>
                    <FinalPrice lineItem={material} readonly />
                  </td>
                </tr>
              ))}
              {!isEmpty(membership) && (
                <tr>
                  <th>{membership.name}</th>
                  <td>{toCurrency(membership.price)}</td>
                  <td>{discount.membership && discount.percentage && `-${discount.amount}%`}</td>
                  <td>
                    <FinalPrice lineItem={membership} readonly />
                  </td>
                </tr>
              )}
              {donation.id && (
                <tr>
                  <th>Donation</th>
                  <td>{toCurrency(donation.price)}</td>
                  <td />
                  <td>
                    <FinalPrice lineItem={donation} readonly />
                  </td>
                </tr>
              )}
              {internationalFees.map((fee) => (
                <tr key={fee.id}>
                  <th>{fee.name}</th>
                  <td>{toCurrency(fee.price)}</td>
                  <td />
                  <td>
                    <FinalPrice lineItem={fee} readonly />
                  </td>
                </tr>
              ))}
              <tr>
                <th>Total</th>
                <td>{toCurrency(totalPrices.total)}</td>
                <td>{!isEmpty(discount) && !discount.percentage && `-${toCurrency(discount.amount)}`}</td>
                <td>{toCurrency(totalPrices.afterDiscount)}</td>
              </tr>
            </tbody>
          </table>
          {trainings.length == 0 && (
            <Fragment>
              <p className="subtext">
                * These items will be charged immediately upon submission, the remaining balance will be charged once
                your registration has been accepted.
                <br />
                <span className="font-weight-bold ml-2">
                  You will also be required to pay an estimated {toCurrency(examPrice.total)} exam fee once your
                  registration has been approved.
                </span>
              </p>
            </Fragment>
          )}
        </FormGroup>

        {/* TODO: Add back in once we get the cert agreement link */}
        {/* {isAFC && (
          <Fragment>
            <Checkbox
              name="certAgreement"
              label={
                <span>
                  I have reviewed and agree to abide by the{' '}
                  <a href={routes.wordPress.certAgreement} target="_blank">
                    Certification Agreement
                  </a>
                </span>
              }
              checked={certAgreement}
              onChange={() => this.setState({ certAgreement: !certAgreement })}
            />
            <Checkbox
              className="mb-3"
              name="candidateHandbook"
              label={
                <span>
                  I have reviewed and agree to abide by the policies outlined in the{' '}
                  <a href={routes.wordPress.afcHandbook} target="_blank">
                    Candidate Handbook
                  </a>
                </span>
              }
              checked={candidateHandbook}
              onChange={() => this.setState({ candidateHandbook: !candidateHandbook })}
            />
          </Fragment>
        )} */}

        <Footer
          step={step}
          setStep={setStep}
          // TODO: Add back in once we get the cert agreement link
          // disabled={isAFC && (!certAgreement || !candidateHandbook)}
          finishBtn={() => {
            if (reviews.length > 0 && !lastReview.approved) {
              return (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() =>
                    apiProcessPayment(registration.id, { stepName: name })
                      .then(({ data }) => updateRegistration(data))
                      .then(() => handleSuccessBase())
                      .catch(() => handleErrorBase())
                  }
                >
                  Submit
                </button>
              );
            }

            return (
              <StripeCheckout
                name="Sage Financial Solutions"
                description="Registration Payment"
                // TODO: Add back in once we get the cert agreement link
                // disabled={isAFC && (!certAgreement || !candidateHandbook)}
                amount={Number(totalPrices.afterDiscount)}
                pay={(token, overrides = {}) =>
                  apiProcessPayment(registration.id, { stepName: name, token, ...overrides })
                    .then(({ data }) => updateRegistration(data))
                    .then(() =>
                      history.push(routes.certificationsAndTraining.register.typePaidBuilder(certification.id)),
                    )
                    .then(() => handleSuccessBase())
                    .catch(() => handleErrorBase())
                }
              />
            );
          }}
        />
      </div>
    );
  }
}

export default withRouter(Summary);
